import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorDocumentId extends IdValueObject {
  static create(value: string): SharingVendorDocumentId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorDocumentId(value);
  }
}
